import { SearchParam } from '../types';

interface BuildOrganizationRedirectUrlParams {
  baseUrl: string;
  id: string;
  name: string;
}

export const buildOrganizationRedirectUrl = ({
  baseUrl,
  id,
  name,
}: BuildOrganizationRedirectUrlParams): string => {
  const queryParams = new URLSearchParams({
    [SearchParam.Organization]: btoa(JSON.stringify({ id, name })),
  });

  return `${baseUrl}?${queryParams.toString()}`;
};
